// preloader control

//wgl.preMat.opacity = 0;
//wgl.precMesh.material.opacity = 0;

page.three.control.preloader.show = function(){
    var wgl = page.three;
    var v = page.three.v.preloader;
    //if(!wgl.precMesh) return false;
    //wgl.preMat.opacity = 1;
    //wgl.precMesh.material.opacity = 1;
    v.aTarget = 1;
    v.aVal = 0.9;
    v.aStep = 1;
}

page.three.control.preloader.hide = function(){
    var wgl = page.three;
    var v = page.three.v.preloader;
    //if(!wgl.precMesh) return false;
    //wgl.preMat.opacity = 0;
    //wgl.precMesh.material.opacity = 0;
    v.aTarget = 0;
    v.aVal = 0.1;
    v.aStep = -1;
}


page.three.control.preloader.fadeIn = function(t){
    if(typeof(t) != "number") t = 1000;
    var v = page.three.v.preloader;
    v.aTarget = 1;
    v.aStep = 1/t;
    v.aVal = page.three.preMesh?page.three.preMat.opacity:0;
}

page.three.control.preloader.fadeOut = function(t){
    if(typeof(t) != "number") t = 1000;
    var v = page.three.v.preloader;
    v.aTarget = 0;
    v.aStep = -1/t;
    v.aVal = page.three.preMesh?page.three.preMat.opacity:1;
}

page.three.control.preloader.progress = function(c, t){
    if(typeof(c) != "number") return;
    if(typeof(t) != "number" || t < 1) t = 1;
    c = Math.clamp(c, 0, 1);
    var v = page.three.v.preloader;

    v.pStart = v.progress;
    v.pTarget = c;
    v.pVal = 0;
    v.pStep = 1 / t;
}

page.three.f.preloader.calc = function(){
    var t = page.v.time;
    var wgl = page.three;
    var v = wgl.v.preloader;
    var a = wgl.bgMat.uniforms.alpha;

    if(!wgl.precMesh) return false;
    if(v.wait > 0){
        v.wait -= t.delta;
    }else{
        if(v.aVal != v.aTarget){
            v.aVal += v.aStep * t.delta;
            v.aVal = Math.clamp(v.aVal, 0, 1);
            page.three.preMat.opacity = Math.ease.inOutSin(v.aVal);
            page.three.precMesh.material.opacity = page.three.preMat.opacity;

            if(page.three.preMat.opacity < 0.0001){
                page.three.precMesh.visible = false;
                page.three.preMesh.visible = false;
            }else{
                page.three.precMesh.visible = true;
                page.three.preMesh.visible = true;
            }
        }
        if(v.pVal != 1){
            v.pVal += v.pStep * t.delta;
            v.pVal = Math.clamp(v.pVal, 0, 1);
            if(v.pVal >= 1){
                v.progress = v.pTarget;
            }else{
                v.progress = THREE.Math.lerp(v.pStart, v.pTarget, Math.ease.outSin(v.pVal));
            }
        }
    }
    var cosanim = (Math.cos((t.current*0.0032)%Math.PI*0.94 + 0.03)+1)/2;
    if(page.three.preMat.opacity != 0){
        wgl.preMesh.rotation.z = (cosanim*cosanim*cosanim)*Math.PI*2 + Math.PI/4;
        wgl.precMesh.geometry.dispose();
        wgl.precGeo = new THREE.CylinderBufferGeometry(0.32, 0.3, 0.01, 24, 1,true, 0, Math.PI * v.progress * 2);
        wgl.precMesh.geometry = wgl.precGeo;
    }
}